
<div class="modalOnboarding" *ngIf="showOnboarding">
    <div class="blurLayer"></div>
    <app-onboarding [usuario]="nombreUsuario" [id_usuario]="idUsuario" (cerrarOnboarding)="toggleOnboarding($event)" ></app-onboarding>
</div>

<footer>
    <div class="container">
        <div class="row firstRow align-items-center">
            <div class="col-6 col-lg-4">
                <strong>Mapa de Sitio</strong>
                <div class="listCont" *ngIf="logged">
                    <ul>
                        <li><a routerLink="/inicio" routerLinkActive="active" ariaCurrentWhenActive="page">Inicio</a></li>
                        <li><a routerLink="/masterclasses" routerLinkActive="active" ariaCurrentWhenActive="page">Masterclasses</a></li>
                        <li *ngIf="shouldShowPuntoCima()"><a [routerLink]="'/contenido/masterclass/' + contenidoEspecial" routerLinkActive="active" ariaCurrentWhenActive="page">Punto CIMA</a></li>
                        <!-- <li><a routerLink="/sesiones" routerLinkActive="active" ariaCurrentWhenActive="page">Sesiones</a></li>
                        <li><a routerLink="/sesiones" routerLinkActive="active" ariaCurrentWhenActive="page">Lives</a></li> -->
                        <li *ngIf="shouldShowCapsulas()"><a routerLink="/capsulas" routerLinkActive="active" ariaCurrentWhenActive="page">Capsulas</a></li>
                        <li *ngIf="shouldShowCapsulas()"><a routerLink="/casos-clinicos" routerLinkActive="active" ariaCurrentWhenActive="page">Casos Clínicos</a></li>
                        <li (click)="toggleOnboarding(true)">Ayuda</li>
                    </ul>
                    <ul>
                        
                        <li><a routerLink="/podcast" routerLinkActive="active" ariaCurrentWhenActive="page">Podcast</a></li>
                        <li *ngIf="shortsEnabled && hasAvailableShorts"><a routerLink="/shorts" routerLinkActive="active" ariaCurrentWhenActive="page">Shorts</a></li>
                        <li><a routerLink="/mi-aprendizaje" routerLinkActive="active" ariaCurrentWhenActive="page">Mi Aprendizaje</a></li>
                        <li><a routerLink="/mi-perfil" routerLinkActive="active" ariaCurrentWhenActive="page">Perfil</a></li>
                        <!-- <li *ngIf="permisoRegistrar"><a routerLink="/alta-usuarios" routerLinkActive="active" ariaCurrentWhenActive="page">Médicos Carmen 3.0</a></li> -->
                    </ul>
                </div>

                <div class="listCont" *ngIf="!logged">
                    <ul>
                        <li><a routerLink="/inicio" routerLinkActive="active" ariaCurrentWhenActive="page">Iniciar Sesión</a></li>
                    </ul>
                    <ul>
                        <li><a routerLink="/sesiones" routerLinkActive="active" ariaCurrentWhenActive="page">Registrarse</a></li>
                    </ul>
                </div>
            </div>
            <div class="col-6 col-lg-4 text-center">
                <img src="../../../../assets/logoMedclass.png" class="logo">
            </div>
        </div>
        <div class="row secondRow align-items-center">
            <div class="col-12 col-lg-4 text-center text-lg-start mt-0 mt-lg-4">
                <a href="/politica-de-privacidad">Política de privacidad</a>
                <a href="/terminos-y-condiciones">Términos y condiciones</a>
                <div class="aviso">Aviso de publicidad No. 223300202C3252</div>
            </div>

            <div class="col-12 col-lg-4 text-center">
                <div class="label">Avalado por</div>
                <div class="row imgRow">
                    <!-- <div class="col-3"> -->
                        <!-- <div class="imageCont" style="background-image: url(../../../../assets/imagen1-ft.png);"></div> -->
                        <img src="../../../../assets/silanesFter.png" alt="">
                        <img src="../../../../assets/carlosFter.png" alt="">
                        <img src="../../../../assets/ametdFter.png" alt="">
                        <img src="../../../../assets/ampacFter.png" alt="">
                        
                    <!-- </div> -->
                    <!-- <div class="col-6"> -->
                        <!-- <div class="imageCont" style="background-image: url(../../../../assets/imagen2-ft.png);"></div> -->
                    <!-- </div> -->
                    <!-- <div class="col-3"> -->
                        <!-- <div class="imageCont" style="background-image: url(../../../../assets/imagen3-ft.png);"></div> -->
                    <!-- </div> -->
                </div>
            </div>

            <div class="col-12 col-lg-4 anio text-center mt-0 mt-lg-4">
                © 2025 Laboratorios Silanes
            </div>
        </div>
    </div>
</footer>
